import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSettingsSettingWeekends,
  initializeSettingsSettingWeekendsScreen,
  setDeleteConfirmationPopupVisibility,
  exportSettingsSettingWeekends,
  saveSettingWeekendsTableState,
} from "../../../redux/actions/Settings/SettingsSettingWeekends";
import SettingsSettingWeekends from '../../../component/Settings/SettingsSettingWeekends';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function SettingsSettingWeekendsScreen(props) {
  const {
    fetchSettingsSettingWeekends,
    initSettingsSettingWeekendsScreen,
    showPageLevelLoader,
    SettingsSettingWeekendsListview,
    paginationInfo,
    screenPermissions,
    exportSettingsSettingWeekends,
    isSettingsSettingWeekendsExportError,
    isSettingsSettingWeekendsExportSuccess,
    isLoading,
    savedTableState,
    saveSettingWeekendsTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initSettingsSettingWeekendsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchSettingsSettingWeekends(savedParams);
    } else {
      fetchSettingsSettingWeekends({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newProps = {
      ...props
    }
    fetchSettingsSettingWeekends(newProps);
  };

  const handleTableStateChange = (tableState) => {
    saveSettingWeekendsTableState(tableState);
  };

  const handleCreateSettingsSettingWeekends = () => {
    navigate(APP_URLS.SETTINGS_SETTINGWEEKENDS.CREATE);
  }
  const editSettingsSettingWeekendsRoute = (id) => {
    const path = generatePath(APP_URLS.SETTINGS_SETTINGWEEKENDS.EDIT, {
      id,
    });
    navigate(path);
  };
  const SettingsSettingWeekendsProps = {
    handleCreateSettingsSettingWeekends,
    exportSettingsSettingWeekends,
    isSettingsSettingWeekendsExportError,
    isSettingsSettingWeekendsExportSuccess,
    editSettingsSettingWeekendsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchSettingsSettingWeekendss: loadLazyData,
    tableData: {
      columns: SettingsSettingWeekendsListview?.columns,
      rows: SettingsSettingWeekendsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <SettingsSettingWeekends
        {...SettingsSettingWeekendsProps}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initSettingsSettingWeekendsScreen: () => dispatch(initializeSettingsSettingWeekendsScreen()),
    fetchSettingsSettingWeekends: (payload) => dispatch(fetchSettingsSettingWeekends(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportSettingsSettingWeekends: (payload) => dispatch(exportSettingsSettingWeekends(payload)),
    saveSettingWeekendsTableState: (payload) => dispatch(saveSettingWeekendsTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isSettingsSettingWeekendsCreateSuccess: selectFromSettingsSettingWeekendsReducer(
      state,
      "isSettingsSettingWeekendsCreateSuccess"
    ),
    SettingsSettingWeekendsListview: selectFromSettingsSettingWeekendsReducer(
      state,
      "SettingsSettingWeekendsListview"
    ),
    showPageLevelLoader: selectFromSettingsSettingWeekendsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromSettingsSettingWeekendsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromSettingsSettingWeekendsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromSettingsSettingWeekendsReducer(
      state,
      "isFetchingGridData"
    ),
    isSettingsSettingWeekendsExportError: selectFromSettingsSettingWeekendsReducer(
      state,
      "isSettingsSettingWeekendsExportError"
    ),
    isSettingsSettingWeekendsExportSuccess: selectFromSettingsSettingWeekendsReducer(
      state,
      "isSettingsSettingWeekendsExportSuccess"
    ),
    savedTableState: selectFromSettingsSettingWeekendsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromSettingsSettingWeekendsReducer = (state, path) => {
  return selectSettingsSettingWeekendsReducer(state)[path];
};

const selectSettingsSettingWeekendsReducer = ({ SettingsSettingWeekendsReducer }) => {
  return SettingsSettingWeekendsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(SettingsSettingWeekendsScreen);
